var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as classNames from 'classnames';
import * as React from 'react';
import * as style from './Button.styl';
import { Spinner } from '@ReactComponents/Spinner/Spinner';
export class Button extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const _a = this.props, { alt, primary, primaryGhost, positive, positiveGhost, negative, negativeGhost, whiteGhost, disabled, spinning, children, onClick, icon, showIconOnHover, xsmall, small, large, full, nav, primaryNav, secondaryNav, type, className } = _a, other = __rest(_a, ["alt", "primary", "primaryGhost", "positive", "positiveGhost", "negative", "negativeGhost", "whiteGhost", "disabled", "spinning", "children", "onClick", "icon", "showIconOnHover", "xsmall", "small", "large", "full", "nav", "primaryNav", "secondaryNav", "type", "className"]);
        const buttonClassNames = classNames(style.global, className, {
            alt: alt,
            primary: primary,
            primaryGhost: primaryGhost,
            positive: positive,
            positiveGhost: positiveGhost,
            negative: negative,
            negativeGhost: negativeGhost,
            whiteGhost: whiteGhost,
            disabled: disabled,
            spinning: spinning,
            showIconOnHover: showIconOnHover,
            xsmall: xsmall,
            small: small,
            large: large,
            full: full,
            nav: nav,
            primaryNav: primaryNav,
            secondaryNav: secondaryNav
        });
        return (_jsxs("button", Object.assign({ disabled: disabled, className: buttonClassNames, onClick: onClick, type: type }, other, { children: [Boolean(icon) && _jsx("span", { className: classNames('iconName', 'icon', 'icon-' + icon) }), showIconOnHover && _jsx("span", { className: classNames('showIconOnHover', 'icon', 'icon-' + showIconOnHover) }), spinning ? _jsx(Spinner, {}) : null, !spinning ? _jsx("span", { children: children }) : null] })));
    }
}
